import Swal from "sweetalert2";
import axios from "../../axios";
import { setAlert } from "./alert";
import { ADD_PACKAGE_ROLE, DELETE_PACKAGE_ROLE, GET_PACKAGE_ROLES, UPDATE_PACKAGE_ROLE, UPDATE_PACKAGE_ROLE_STATUS } from "../types";
import { getErrorMessage } from "../../helpers/ErrorMessage";

export const addPackageRole = (formData) => async (dispatch) => {
  try {
    const res = await axios.post("package/role/add", formData);
    if (res.data.code === 1) {
      dispatch({ type: ADD_PACKAGE_ROLE, payload: res.data.data });
      Swal.fire({
        title: 'Success!',
        text: res.data.message,
        icon: 'success',
    });
      dispatch(setAlert(res.data.message, "success"));
      if (res.data.code === 0) {
        console.log("here :", res.data.message);  
        Swal.fire({
          title: 'warning!',
          text: res.data.message,
          icon: 'warning',
      });
    }
    } else {
      dispatch(setAlert(res.data.message, "warning"));
      Swal.fire({
        title: 'warning!',
        text: res.data.message,
        icon: 'warning',
      });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
    // const errorMessage =
    //   err.response?.data?.message || "An unexpected error occurred";
    const errorMessage = getErrorMessage(err.response?.data);

    Swal.fire({
      title: "Error!",
      text: errorMessage,
      icon: "error",
    });
  }
};
export const getPackageRole = () => async (dispatch) => {
  try {
    const res = await axios.get("package/role/all");
    // console.log("state :", res.data);
    if (res.data.code === 1) {
      dispatch({ type: GET_PACKAGE_ROLES, payload: res.data.data });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};


export const updatePackageRole = (formData) => async (dispatch) => {
  try {

    const updatedFormData = {
      id: formData.id,
      ...(formData.role && { role: formData.role }),
      // ...(formData.status !== undefined && { status: formData.status }),
    };
    
    const res = await axios.post("package/role/update", updatedFormData);
    if (res.data.code === 1) {
      dispatch({ type: UPDATE_PACKAGE_ROLE, payload: res.data.data });
      Swal.fire({
        title: 'Success!',
        text: res.data.message,
        icon: 'success',
    });
      dispatch(setAlert(res.data.message, "success"));
    } else {
      dispatch(setAlert(res.data.message, "warning"));
      Swal.fire({
        title: 'warning!',
        text: res.data.message,
        icon: 'warning',
    });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};

export const updatePackageRoleStatus = (formData) => async (dispatch) => {
  try {

    const updatedFormData = {
      id: formData.id,
      // ...(formData.role && { role: formData.role }),
      ...(formData.status !== undefined && { status: formData.status }),
    };
    
    const res = await axios.post("package/role/update/status", updatedFormData);
    if (res.data.code === 1) {
      dispatch({ type: UPDATE_PACKAGE_ROLE_STATUS, payload: res.data.data });
      Swal.fire({
        title: 'Success!',
        text: res.data.message,
        icon: 'success',
    });
      dispatch(setAlert(res.data.message, "success"));
    } else {
      dispatch(setAlert(res.data.message, "warning"));
      Swal.fire({
        title: 'warning!',
        text: res.data.message,
        icon: 'warning',
    });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};


export const deletePackageRole = (id) => async (dispatch) => {
  try {
    if (!id) {
      dispatch(setAlert("Please select any record", "warning"));
      return false;
    }
    const res = await axios.post(`package/role/delete/${id}`);
    if (res.data.code === 1) {
      dispatch({ type: DELETE_PACKAGE_ROLE, payload: { id } });
      Swal.fire({
        title: 'Success!',
        text: res.data.message,
        icon: 'success',
    });
      dispatch(setAlert(res.data.message, "success"));
    } else {
      dispatch(setAlert(res.data.message, "warning"));
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};
